@if (loading) {
  <app-spinner message='Fetching results…'></app-spinner>
}
@if (!loading && pdfUrl !== undefined) {
  <div>
    <iframe [attr.src]="pdfUrl" id="emb-pdf" ></iframe>
  </div>
}
